<template>
  <main>
    <banner :title="feedbackMessage" :active.sync="showBanner"   />
    <banner :title="feedbackMessageLever" :active.sync="showBannerLever"   />
    <dropdown-modal :title="this.$t('login.emailTitle')" :active.sync="modalActive">
      <stack-confirm-link />
    </dropdown-modal>
    <sidebar-modal :active.sync="greenHouseModal" :title="atsTitle">
      <component v-bind:is="atsComponent" :companies="companies" :toggleGreenHouseModal="toggleGreenHouseModal"></component>
    </sidebar-modal>
    <dropdown-modal  title="ARE YOU SURE?" :active.sync="disconnectModal">
      <p>Once disconnected your jobs and applicants will no longer sync between you HireVibes account and your {{ATS}} ATS</p>
      <button @click="disconnectGreenHouseHandler" class="button is-danger is-fullwidth"><spinner size="small" v-if="disconnectLoading" ></spinner><p v-else>DISCONNECT</p></button>
    </dropdown-modal>
    <p v-if="message" class="m-b-10">{{message}}</p>
    <div v-if="authenticated">
      <h5 class="m-b-16">{{this.$t('wallet.connectedTo')}} {{activeProvider.meta.name}} <span v-if="linkedAccount">• {{linkedAccount.account}}</span></h5>
      <button class="button is-primary is-outlined m-b-8" @click="disconnect"><span v-if="!connecting" class="h-icon" :class="'icon-' + wallet.provider.id +'-invert'"></span> {{this.$t('wallet.disconnectWallet')}}</button>
      <p class="text f-14" > {{this.$t('wallet.weUse')}} <span class="has-text-primary">{{getProvidersList}}</span> <span v-html="this.$t('wallet.scatterInfoPhrase')"></span></p>
    </div>
    <div v-else-if="!isWallet" >
      <h5 class="m-b-16">{{getConnectedLabel}}</h5>
      <div  class="providers">
        <div v-if="isStackConnected" :class="isWalletPath">
          <div class="icon-button-container">
            <button v-if="loading" @click="stackDisconnect" class="button is-primary is-outlined no-hover"> <spinner size="small"  class="spinner"></spinner></button>
            <button v-else @click="stackDisconnect" class="button is-primary is-outlined no-hover"><img class="mr-2" src="@/assets/hiro-wallet-blue.png" alt=""> {{this.$t('wallet.disconnectWalletcap')}}</button>
          </div>
        </div>
         <div v-else :class="isWalletPath">
           <div class="icon-button-container" v-if="loading">
             <spinner size="medium"  class="spinner" />
           </div>
           <div class="icon-button-container" v-else>
             <figure @click="authenticateStack" class="image is-48x48 is-cursor-pointer"  title="name">
               <img src="@/assets/hiro-wallet.png" class="is-rounded" alt="name" />
             </figure>
             <h4  class="m-t-8">Hiro Wallet</h4>
           </div>
         </div>

        </div>
      <p class="m-t-8 text f-12" > {{this.$t('wallet.weUse')}}
        <span v-if="isStackConnected" class="has-text-primary link-text" @click="linkHandler('hiro')">{{getProvidersList}}</span>
        <span v-else class="has-text-primary link-text" @click="authenticateStack">{{getProvidersList}}</span>
        <span v-html="this.$t('wallet.scatterInfoPhrase')"></span></p>
    </div>
    <Provider v-else v-for="p in providers"
              :key="p.id"
              :id="p.id"
              :name="p.meta.name"
              :isWallet="isWallet" />

    <div v-if="isWalletPath && isHirer">
      <h4 class="title is-4 m-t-40">
        ATS Integrations
      </h4>
      <columns :is-multiline="true">
        <column size="is-12-mobile is-6-tablet is-4-desktop is-6-widescreen is-6-fullhd">
          <card>
            <div class="  field">
              <field label="Choose Company for Green House Integration">
                <div class=" is-expanded is-fullwidth">
                  <div class="select is-fullwidth">
                    <select v-model="companyId">
                      <option :value="null">Choose Company</option>
                      <option v-for="company in companies" :key="company.id" :value="company.id">
                        {{ company.name }}
                      </option>
                    </select>
                  </div>
                </div>
              </field>
            </div>
            <h5 class="m-b-16" v-if="formCompanyId && !connectLoading && !greenHouseConnected">Connect your ATS account</h5>
            <h5 class="m-b-16" v-if="formCompanyId && !connectLoading && greenHouseConnected">ATS account is Connected</h5>
            <div  class="providers" v-if="formCompanyId && !connectLoading">
              <div v-if="greenHouseConnected" :class="isWalletPath">
                <div class="icon-button-container">
                  <figure v-tooltip="{content:'Connected: Click to disconnect <br> your Greenhouse ATS', placement:'top-start',}" @click="toggleModal('greenHouse')" class="image is-58x58 is-cursor-pointer"  title="name">
                    <img src="@/assets/green-house-active.png" alt="name" />
                  </figure>
                  <h4  class="m-t-8"><strong>Green House</strong></h4>
                </div>
              </div>
              <div v-else :class="isWalletPath">
                <div class="icon-button-container" v-if="loading">
                  <spinner size="medium"  class="spinner" />
                </div>
                <div class="icon-button-container" v-else>
                  <figure @click="toggleGreenHouseModal('greenHouse')" class="image is-48x48 is-cursor-pointer"  title="name">
                    <img src="@/assets/green-house.png" class="is-rounded" alt="name" />
                  </figure>
                  <h4  class="m-t-8"><strong>Green House</strong></h4>
                </div>
              </div>
              <div class="mt-20 " v-if="greenHouseConnected && isHirer">
                <div>
                  <text-field label="Webhook URL" placeholder="TestWHURL" v-model="formWebhookUrl" readonly/>
                  <a :class="getCopyStyle"
                     v-clipboard:copy="formWebhookUrl"
                     v-clipboard:success="onCopy">
                    {{$t('referrals.copyToClipboard')}}
                    <small class="copy-lbl" v-if="copyToClipboardWebhook">{{this.$t('profile.copied')}}!</small>
                  </a>
                </div>
                <div>
                  <text-field label="Auth username" placeholder="TestAUN" v-model="formAuthUsername" readonly/>
                  <a :class="getCopyStyleUsername"
                     v-clipboard:copy="formAuthUsername"
                     v-clipboard:success="onCopyUsername">
                    {{$t('referrals.copyToClipboard')}}
                    <small class="copy-lbl" v-if="copyToClipboardUsername">{{this.$t('profile.copied')}}!</small>
                  </a>
                </div>
                <div>
                  <text-field label="Auth password" placeholder="xxxxxx"  v-model="authRegPassword" readonly/>
                  <p class="copyClipboard" v-if="gpLoading">
                    Loading...
                  </p>
                  <a class="copyClipboard" @click="generateNewPassword" v-else>
                    <p>Generate New Password</p>
                  </a>
                </div>
              </div>
            </div>
            <div v-if="connectLoading" class="mt-20 is-flex is-flex-column flex-center content-center">
              <div><spinner size="large"></spinner></div>
              <h3 class="heading">Loading...</h3>
            </div>
          </card>
        </column>
        <lever-card :toggleModal="toggleModal"  :toggleGreenHouseModal="toggleGreenHouseModal" :companies="companies"></lever-card>
      </columns>
    </div>

  </main>
</template>

<script>
import {mapActions, mapGetters, mapState, mapMutations} from 'vuex'
import Spinner from 'vue-simple-spinner'
import Heading from '@/components/general/heading'
import Provider from '@/components/wallet/provider'
import ProviderWithIcon from '@/components/wallet/provider-with-icon'
import {authenticate, userSession, getSignature} from '@/helpers/stack-auth'
import Wallet from '@/api/wallet'
import DropdownModal from '@/components/dropdown-modal'
import StackConfirmLink from '@/components/wallet/stack-confirm-link'
import UserImage from '@/components/general/user-image'
import GreenHouseForm from '../settings/green-house-form'
import Banner from '@/components/general/banner'
import TextField from '@/components/general/text-field'
import Companies from '@/api/companies'
import Field from '@/components/general/field'
import Columns from '@/components/general/columns'
import Column from '@/components/general/column'
import Card from '@/components/general/card'
import LeverCard from '../settings/lever-card'
import SidebarModal from '../sidebar-modal'
import LeverForm from '../settings/lever-form'

export default {
  props: {
    isWallet: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      loading: false,
      modalActive: false,
      greenHouseModal: false,
      disconnectModal: false,
      copyToClipboardWebhook: false,
      copyToClipboardUsername: false,
      companies: [],
      atsComponent: '',
      atsModalTitle: '',
      currentAts: 'greenHouse'
    }
  },
  components: {
    SidebarModal,
    LeverCard,
    Field,
    TextField,
    Heading,
    Provider,
    ProviderWithIcon,
    Spinner,
    DropdownModal,
    StackConfirmLink,
    UserImage,
    GreenHouseForm,
    Banner,
    Columns,
    Column,
    Card,
    LeverForm
  },
  computed: {
    ...mapState('users', ['user']),
    ...mapState('greenHouse', {
      greenHouseConnected: 'greenHouseConnected',
      error: 'error',
      feedbackMessage: 'feedbackMessage',
      disconnectLoadingGreenHouse: 'disconnectLoading',
      connectLoading: 'loading',
      formWebhookUrl: 'webhookUrl',
      formAuthUsername: 'authUsername',
      formAuthPassword: 'authRegPassword',
      gpLoading: 'gpLoading',
      authRegPassword: 'authRegPassword',
      formCompanyId: 'companyId'
    }),
    ...mapState('lever', {
      feedbackMessageLever: 'feedbackMessage',
      errorLever: 'error',
      disconnectLoadingLever: 'disconnectLoading'
    }),
    ...mapState('sigproviders', [
      'authenticated',
      'message',
      'wallet',
      'activeProvider',
      'connecting'
    ]),
    ...mapState('wallet', [
      'linkedAccount', 'isStackConnected', 'stackUserData'
    ]),
    ...mapGetters('sigproviders', [
      'providers',
      'account'
    ]),
    disconnectLoading () {
      return this.currentAts === 'greenHouse' ? this.disconnectLoadingGreenHouse : this.disconnectLoadingLever
    },
    webhookUrl: {
      get () { return this.formWebhookUrl },
      set (value) { }
    },
    authUsername: {
      get () { return this.formAuthUsername },
      set (value) { }
    },
    authPassword: {
      get () { return this.formAuthPassword },
      set (value) { }
    },
    companyId: {
      get () { return this.formCompanyId },
      set (value) { this.setCompanyId(value); if (value) { this.resetGreenhouseForm(); this.checkGreenHouseStatus() } }
    },
    getCopyStyle () {
      return this.copyToClipboardWebhook ? 'copyClipboard copyClipboardClicked' : 'copyClipboard'
    },
    getCopyStyleUsername () {
      return this.copyToClipboardUsername ? 'copyClipboard copyClipboardClicked' : 'copyClipboard'
    },
    showBanner: {
      get () {
        return this.feedbackMessage || false
      },
      set () {
        this.setFeedbackMessage(null)
        this.setError(false)
      }
    },
    showBannerLever: {
      get () {
        return this.feedbackMessageLever || false
      },
      set () {
        this.setFeedbackMessageLever(null)
        this.setErrorLever(false)
      }
    },
    ATS () {
      return this.currentAts === 'lever' ? 'Lever' : 'GreenHouse'
    },
    getConnectedLabel () {
      return this.isStackConnected ? this.$t('wallet.connectedToHiro') : this.$t('wallet.connectYourStacks')
    },
    getProvidersList () {
      const prods = ['Hiro Wallet']
      // this.providers.forEach(p => {
      //   prods.push(p.meta.name)
      // })
      return prods.join(', ')
    },
    isWalletPath () {
      return this.$router.history.current.path === '/wallet' ? '' : 'outer-container'
    },
    isHirer () {
      return !!(this.user && (this.user.profile === 'hirer' || this.user.profile === 'jobboardowner'))
    },
    atsTitle () {
      return this.atsComponent === 'GreenHouseForm' ? 'CONNECT TO GREENHOUSE' : 'CONNECT TO LEVER'
    }
  },
  methods: {
    ...mapActions('sigproviders', [
      'initProviders',
      'detectSignatureProvider'
    ]),
    ...mapActions('greenHouse', ['disconnectGreenHouse', 'generatePassword', 'checkGreenHouseStatus']),
    ...mapActions('domain', ['fetchJobTypes']),
    ...mapActions('wallet', [
      'connectStack', 'disconnectStack'
    ]),
    ...mapActions('lever', {
      disconnectLever: 'disconnectLever'
    }),
    ...mapMutations('lever', {
      setFeedbackMessageLever: 'setFeedbackMessage',
      setErrorLever: 'setError',
      setLeverAuth: 'setLeverAuth'
    }),
    ...mapMutations('wallet', ['setError']),
    ...mapMutations('greenHouse', ['setError', 'setFeedbackMessage', 'setCompanyId', 'resetGreenhouseForm']),
    onCopy () {
      this.copyToClipboardWebhook = true
      setTimeout(() => {
        this.copyToClipboardWebhook = false
      }, 2000)
    },
    toggleModal (type = 'greenHouse') {
      this.disconnectModal = !this.disconnectModal
      this.currentAts = type
    },
    onCopyUsername () {
      this.copyToClipboardUsername = true
      setTimeout(() => {
        this.copyToClipboardUsername = false
      }, 2000)
    },
    generateNewPassword () {
      this.generatePassword(this.user.companyId)
    },
    toggleGreenHouseModal (type) {
      if (type === 'greenHouse') {
        this.atsComponent = 'GreenHouseForm'
      } else {
        this.atsComponent = 'LeverForm'
      }
      this.greenHouseModal = !this.greenHouseModal
    },
    toggleDisconnect () {
      this.disconnectModal = !this.disconnectModal
    },
    contactHandler () {
    },
    linkHandler (wallet) {
      switch (wallet) {
        case 'hiro':
          window.open('https://www.hiro.so/wallet', '_blank').focus()
          break
        default:
          break
      }
    },
    async stackDisconnect () {
      try {
        this.loading = true
        const res = await Wallet.disconnectWallet()
        if (res.hasOwnProperty('detached') && res.detached) {
          userSession.signUserOut()
          this.disconnectStack()
        }
        this.loading = false
      } catch (e) {
        this.loading = false
        this.setError(e.message)
      }
    },
    async stackConnect (userData, user) {
      try {
        if (user.hasOwnProperty('public_keys')) {
          this.loading = true
          const {randomCharacters} = await Wallet.initiateWallet()
          const signObj = await getSignature(userData.appPrivateKey, randomCharacters)

          const walletPayload = {
            publicKey: signObj.publicKey,
            signature: signObj.signature,
            stacksAddress: user.profile.stxAddress.mainnet
          }
          const stackConnectRes = await Wallet.verifyAttachment(walletPayload)
          if (stackConnectRes) {
            this.modalActive = true
            this.$store.dispatch('users/getUser')
            this.$store.dispatch('wallet/getStackWalletStatus')
          }
          this.loading = false
        }
      } catch (e) {
        this.loading = false
        this.setError(e.message)
        console.log('test error', e.message)
      }
    },
    async authenticateStack () {
      await authenticate(this.stackConnect)
    },
    disconnect () {
      this.$store.dispatch('sigproviders/disconnectWallet')
    },
    disconnectGreenHouseHandler (type) {
      if (this.currentAts === 'lever') {
        this.disconnectLever({toggle: this.toggleDisconnect})
      } else {
        this.disconnectGreenHouse({toggle: this.toggleDisconnect})
      }
    }

  },
  async created () {
    try {
      await this.initProviders()
      this.detectSignatureProvider()
    } catch (e) {
      console.log('error created', e)
    }
  },
  async mounted () {
    try {
      if (this.$route.fullPath.includes('code')) {
        this.setLeverAuth(this.$route.query.code)
        this.$router.push('/settings/eos-account')
      }
      this.fetchJobTypes()
      const companies = await Companies.all()
      this.companies = companies
    } catch (e) {
      console.log('error', e)
    }
  }
}
</script>

<style scoped lang="scss">
  @import '~@/styles/defaults.scss';
  .providers {
    .provider {
      display: inline-block;
    }
  }
  .button {
    &.is-primary {
      &.is-outlined {
        background-color: #fff;
        &:hover {
          color: $primary-hover;
        }
      }
    }
  }

  .outer-container{
    display: flex;flex-direction: row; justify-content: flex-start
  }

  .no-hover{
    color:#44c7f0 !important;
  }
  .mr-2{
    margin-right: 6px;
  }
 .icon-button-container{
   display: flex;flex-direction: column; align-items: center
 }
 .link-text{
   cursor: pointer;
 }
 .is-58x58{
   width: 58px !important;
 }
  .copyClipboard {
    font-size: 12px;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    letter-spacing: normal;
    color: #44C7F0;
    position: relative;
    top: -15px;

    .copy-lbl {
      font-size: 7px;
      padding: 2px 3.5px;
      border-radius: 2.6px;
      letter-spacing: 1px;
      position: relative;
      top: -2px;
      left: 2px;
    }
  }

  .copyClipboardClicked{
    color: #44C7F0;
    font-weight: bold;
    .copy-lbl{
      font-size: 9px;
      font-weight: bold;
      padding: 2px 3.5px;
      border-radius: 2.6px;
      letter-spacing: 1px;
      position: relative;
      top: -2px;
      left: 2px;
    }
  }
  .mt-20{
    margin-top: 20px;
  }
  .mt-8{
    margin-top: 8px;
  }
  .green-house-inputs{
    width: 60%
  }
  @media (max-width: 1200px) {
    .green-house-inputs{
      width: 80%
    }
  }
  @media (max-width: 900px) {
    .green-house-inputs{
      width: 100%
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/wallet/providers.vue